import { c as _c } from "react/compiler-runtime";
import './auth-sign-in.scss';
import OtpForm from './OtpForm.tsx';
import { SignInPageParams } from './signInTypes.ts';
const PROVIDERS = [{
  name: 'google',
  label: 'Google',
  logo: 'https://authjs.dev/img/providers/google.svg'
}, {
  name: 'microsoft',
  label: 'Microsoft',
  logo: 'https://authjs.dev/img/providers/microsoft-entra-id.svg'
}] as const;
type SocialProvider = (typeof PROVIDERS)[number]['name'];
export default function SignInPage(params) {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = PROVIDERS.map(t1 => {
      const {
        name,
        label,
        logo
      } = t1;
      return <div className="provider" key={name}><form><button onClick={async e => {
            e.preventDefault();
            return socialSignIn(name, params);
          }}><span className="provider-text">Sign in with {label}</span><img loading="lazy" height={24} alt={`${label} logo`} src={logo} /></button></form></div>;
    });
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <hr />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== params) {
    t2 = <OtpForm {...params} />;
    $[3] = params;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <div className="sign-in-page">{t0}{t1}{t2}</div>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
async function socialSignIn(provider: SocialProvider, params: SignInPageParams) {
  const {
    authClient,
    onError,
    onSuccess,
    onRedirect
  } = params;
  const callbackURL = await params.callbackUrl;
  const errorCallbackURL = await params.errorCallbackUrl;
  console.log('Signing in with ' + provider, {
    callbackURL,
    errorCallbackURL
  });
  try {
    const result = await authClient.signIn.social({
      provider,
      // disableRedirect: true,
      callbackURL,
      errorCallbackURL
    }
    // {
    //   onSuccess(ctx) {
    //     console.log('onSuccess ctx', ctx);
    //   },
    // }
    );
    const {
      data,
      error
    } = result;
    if (typeof data?.url === 'string') {
      console.log('redirect response', data);
      onRedirect(data.url);
    } else if (data?.user) {
      console.log('Signed in:', result);
      onSuccess?.(data);
    } else {
      console.log('Other signIn response:', result);
    }
  } catch (err) {
    console.error('SignIn error:', err);
    if (onError) {
      onError(err?.toString());
    } else {
      throw err;
    }
  }
}